import { css } from 'emotion'

export const TeamLogoWidgetStyles = css``
